module.exports = __webpack_public_path__ + "static/media/noImg.c2679478.png";